import React from "react"
import types from "prop-types"
import FormsyValidation from "shared/FormsyValidation"

const UserTypesSelectedValidation = ({ value = [], sectionIndex, questionIndex }) => (
  <FormsyValidation
    name={`sections[${sectionIndex}].questions[${questionIndex}].userTypesSelected`}
    value={value}
    validations={{
      requiresUserType(_model, val) {
        if (val?.length) return true
        return "Must select at least one answer option"
      },
    }}
  />
)

UserTypesSelectedValidation.propTypes = {
  value: types.arrayOf(types.string),
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default UserTypesSelectedValidation
